"use strict";

class TokenOverviewCtrl {

	constructor ( $rootScope, $http, Token, $transitions ) {

		// Dependencies
		this.$http = $http;
		this._Token = Token;

		this.fetch();

        $transitions.onSuccess({ }, function(transition) {

            let toState = transition.to();

			if( toState.name === 'contact' ) {
				this.fetch();
			}
		});
	}

	fetch () {

		this.$http.get('/tokens').then((response) => {

			this.collection = response.data.data;
		});
	}
}


TokenOverviewCtrl.$inject = ['$rootScope', '$http', 'Token', '$transitions'];


module.exports = TokenOverviewCtrl;
